import { render } from "./SolicitudesTipster.vue?vue&type=template&id=f384df62&scoped=true"
import script from "./SolicitudesTipster.vue?vue&type=script&lang=js"
export * from "./SolicitudesTipster.vue?vue&type=script&lang=js"

import "./SolicitudesTipster.vue?vue&type=style&index=0&id=f384df62&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f384df62"]])

export default __exports__